export default __webpack_public_path__ + "static/media/stunningpunch3.97d963d6.png";